import React from 'react'
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const Nityopasna = () => {
    return (
        <>  
            <PageHeader title="नित्य उपासना " path="/about-goshala" name=" goshala" />
              <div className="comman-template-section">
                                     <div className="comman-template-container">
                                       {/* container  */}
                                       <div className="comman-template-sub-section">
                                         {/* sub-section */}
                                         <div className="comman-template-img-container">
                                           <img
                                             className="comman-template-image"
                                             src={sansthanImg.nityopasana}
                                             alt=""
                                           />
                                         </div>
                                         <div className="comman-template-info-container">
                                           <h3>	नित्य उपासना </h3>
                                           <p>
                                            <ul>
                                                <li>रोज प्रातःकाळी ५ ते ७ श्रींची काकडा आरती व भूपाळी. </li>
                                                <li>रोज सकाळी सात ते सव्वा आठ या वेळेमध्ये श्रींची नित्य महा अभिषेक पूजा संपन्न होते. </li>
                                                <li>सव्वा आठ ते नऊ या वेळेमध्ये श्रींची अनेक भक्तगणांच्या उपस्थितीत महाआरती व त्यानंतर संस्कार वर्ग तसेच प्रतिदिनी १५ मिनिटे सत्संग विचारधारा श्रींच्या सेवेत समर्पित होते.</li>
                                                <li>दुपारी एक वाजता श्रींना माध्यान्ह महानैवेद्य.</li>
                                                <li> सायंकाळी सहा ते साडेसात हरिपाठ व "श्री" ची सायं धूपारती व उपासना</li>
                                            </ul>
                                            
                                           </p>
                                         </div>
                                       </div>
                                       {/* second one  */}
                             
                                       <div className="comman-template-sub-section"></div>
                                     </div>
                                   </div>
        </>
    );
}
